import { ActionText } from '@components/action-text';
import { Avatar } from '@components/avatar';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { Color, Font } from '@styles/theme';

export type LabelAvatarNameGroupProps = {
  label: string;
  name?: string;
  image?: string;
  hideLabel?: boolean;
  onClick?: () => void;
};

export const LabelAvatarNameGroup = ({
  label,
  name,
  image,
  hideLabel,
  onClick,
}: LabelAvatarNameGroupProps) => {
  const { t } = useScopedTranslate(locale);
  const commonProps = {
    font: 'regular14' as Font,
    color: (name ? 'textPrimary' : 'textHelper') as Color,
    text: name ?? t('nameMissing'),
  };

  return (
    <div>
      {!hideLabel && <Text font="semibold14" text={label} />}
      <Stack orientation="horizontal" align="center" space={2}>
        <Avatar name={name ?? t('noName')} src={image} color="purple" />
        {onClick ? <ActionText {...commonProps} onClick={onClick} /> : <Text {...commonProps} />}
      </Stack>
    </div>
  );
};

const locale = {
  en: {
    noName: 'No name',
    nameMissing: 'Name missing',
  },
};
